import React from 'react';
import { FC } from 'react';
import styled from 'styled-components';

const _bullhorn: FC<{ className?: string; fillColor?: string }> = ({ className, fillColor }) => (
    <svg className={className} width='27' height='27' viewBox='0 0 27 27' xmlns='http://www.w3.org/2000/svg' fill={fillColor ?? '#FFFFFF'}>
        <g id='bullhorn-solid 1'>
            <path
                id='Vector'
                d='M23.25 2.96289L21.9551 3.90234C21.9551 3.90234 20.3396 5.10205 18.0195 6.28906C15.6995 7.47607 12.678 8.625 10.0215 8.625H2.125V16.0391L2.15039 16.166L3.77539 21.8535L3.95312 22.4375H8.87891L8.59961 21.3965L7.2793 16.75H10.0215C12.6431 16.75 15.6646 17.9211 17.9941 19.1113C20.3237 20.3015 21.9551 21.4727 21.9551 21.4727L23.25 22.4121V14.9727C24.1895 14.6331 24.875 13.738 24.875 12.6875C24.875 11.637 24.1895 10.7419 23.25 10.4023V2.96289ZM21.625 5.98438V19.3652C20.9521 18.9114 20.4189 18.4988 18.7305 17.6387C16.3438 16.4199 13.262 15.1853 10.25 15.125V10.25C13.2905 10.1897 16.3755 8.92969 18.7559 7.71094C20.4412 6.84766 20.9585 6.43823 21.625 5.98438ZM3.75 10.25H8.625V15.125H3.75V10.25ZM4.0293 16.75H5.57812L6.7207 20.8125H5.17188L4.0293 16.75Z'
            />
        </g>
    </svg>
);

const Bullhorn = styled(_bullhorn)``;
export default Bullhorn;
